import http from './http';

class ImageUploadService {
    uploadImage(payload) {
        return http.post('/upload', payload, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }
}

export default new ImageUploadService(); 
